import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-resize"
// Allows resizing the sidebar by dragging the handle between sidebar and main content
export default class extends Controller {
  static targets = ["sidebar", "handle"]

  static values = {
    min: { type: Number, default: 57 },
    max: { type: Number, default: 500 },
    default: { type: Number, default: 240 }
  }

  connect() {
    this.dragging = false
    this.boundPointerMove = this.pointerMove.bind(this)
    this.boundPointerUp = this.pointerUp.bind(this)

    const saved = localStorage.getItem("sidebarWidth")
    if (saved) {
      this.applyWidth(parseInt(saved, 10))
    }
  }

  pointerDown(event) {
    // Only respond on medium+ screens
    if (window.innerWidth < 768) return

    event.preventDefault()
    this.dragging = true
    this.sidebarTarget.classList.add("!transition-none")
    this.handleTarget.classList.add("bg-indigo-500/60")
    document.body.style.cursor = "col-resize"
    document.body.style.userSelect = "none"
    document.addEventListener("pointermove", this.boundPointerMove)
    document.addEventListener("pointerup", this.boundPointerUp)
  }

  pointerMove(event) {
    if (!this.dragging) return

    const containerRect = this.element.getBoundingClientRect()
    let width = event.clientX - containerRect.left
    width = Math.max(this.minValue, Math.min(this.maxValue, width))
    this.applyWidth(width)
  }

  pointerUp() {
    if (!this.dragging) return

    this.dragging = false
    this.sidebarTarget.classList.remove("!transition-none")
    this.handleTarget.classList.remove("bg-indigo-500/60")
    document.body.style.cursor = ""
    document.body.style.userSelect = ""
    document.removeEventListener("pointermove", this.boundPointerMove)
    document.removeEventListener("pointerup", this.boundPointerUp)

    const currentWidth = this.sidebarTarget.offsetWidth
    localStorage.setItem("sidebarWidth", currentWidth)
  }

  applyWidth(width) {
    this.sidebarTarget.style.width = `${width}px`
  }

  disconnect() {
    document.removeEventListener("pointermove", this.boundPointerMove)
    document.removeEventListener("pointerup", this.boundPointerUp)
  }
}
